import { createSlice } from "@reduxjs/toolkit";


//This is a default template.to be remobed once added in redux

const initialState = {
  propertySubType: [],
  category: [],
  propertyStatus: [],
  occupancyStatus: [],
  sid: [],
  propertyShowMoreStatus: [],
  bathrooms: "",
  bedrooms: "",
  price: {
    min: 0,
    max: 0,
  },
  area: {
    min: 0,
    max: 0,
  },
  builtYear: {
    min: 0,
    max: 0,
  },
  sort: { value: "sort=MostPopular", label: "Most Popular" },
  state: [],
  listingType: "",
  newToHubzu: "",
  marketingPhase: "",
  auctionEndingToday: "",
  ownItNow: "",
  nobuyerpremium: "",
  brokerCoOp: "",
  cashOnly: "",
  campaign: "",
  campaignId: "",
  campaignType: "",
  isPartOfCampaign: "",
  offers: "",
  searchBy: "",
  mapParam: "",
  pageNumber: 1,
};

export const propertiesSlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    addListingType: (state, action) => {
      const value = action?.payload?.value;
      const isUpdate = action?.payload?.isUpdate;
      const isExist = state.listingType === value;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("listingType")) {
            addressBarURL.searchParams.append("listingType", value)
            history.pushState({}, "", addressBarURL.href)
          } else if (addressBarURL.searchParams.has("listingType") && addressBarURL.searchParams.get("listingType") === 'TRNL' && value === "") {
            addressBarURL.searchParams.delete("listingType")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.listingType = value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("listingType") && addressBarURL.searchParams.get("listingType") !== "AUCN") {
            addressBarURL.searchParams.delete("listingType")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.listingType = "";
      }
    },
    addNewToHubzu: (state, action) => {
      const value = action?.payload?.value;
      const isUpdate = action?.payload?.isUpdate;
      const isExist = state.newToHubzu === value;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("newToHubzu")) {
            addressBarURL.searchParams.append("newToHubzu", value)
            history.pushState({}, "", addressBarURL.href)
          } else if (addressBarURL.searchParams.has("newToHubzu") && !value) {
            addressBarURL.searchParams.delete("newToHubzu")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.newToHubzu = value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("newToHubzu")) {
            addressBarURL.searchParams.delete("newToHubzu")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.newToHubzu = "";
      }
    },
    addMarketingPhase: (state, action) => {
      const value = action?.payload?.value;
      const isUpdate = action?.payload?.isUpdate;
      const isExist = state.marketingPhase === value;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("marketingPhase")) {
            addressBarURL.searchParams.append("marketingPhase", value)
            history.pushState({}, "", addressBarURL.href)
          } else if (addressBarURL.searchParams.has("marketingPhase") && !value) {
            addressBarURL.searchParams.delete("marketingPhase")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.marketingPhase = value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("marketingPhase")) {
            addressBarURL.searchParams.delete("marketingPhase")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.marketingPhase = "";
      }
    },
    addAuctionEndingToday: (state, action) => {
      const isExist = state.auctionEndingToday === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("auctionEndingToday")) {
            addressBarURL.searchParams.append("auctionEndingToday", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          } else if (addressBarURL.searchParams.has("auctionEndingToday") && !action.payload.value) {
            addressBarURL.searchParams.delete("auctionEndingToday")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.auctionEndingToday = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("auctionEndingToday")) {
            addressBarURL.searchParams.delete("auctionEndingToday")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.auctionEndingToday = "";
      }
    },
    addOwnItNow: (state, action) => {
      const isExist = state.ownItNow === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("ownItNow")) {
            addressBarURL.searchParams.append("ownItNow", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          } else if (addressBarURL.searchParams.has("ownItNow") && !action.payload.value) {
            addressBarURL.searchParams.delete("ownItNow")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.ownItNow = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("ownItNow")) {
            addressBarURL.searchParams.delete("ownItNow")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.ownItNow = "";
      }
    },
    addNobuyerpremium: (state, action) => {
      const isExist = state.nobuyerpremium === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("nobuyerpremium")) {
            addressBarURL.searchParams.append("nobuyerpremium", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          } else if (addressBarURL.searchParams.has("nobuyerpremium") && !action.payload.value) {
            addressBarURL.searchParams.delete("nobuyerpremium")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.nobuyerpremium = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("nobuyerpremium")) {
            addressBarURL.searchParams.delete("nobuyerpremium")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.nobuyerpremium = "";
      }
    },
    addBrokerCoOp: (state, action) => {
      const isExist = state.brokerCoOp === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("brokerCoOp")) {
            addressBarURL.searchParams.append("brokerCoOp", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          } else if (addressBarURL.searchParams.has("brokerCoOp") && !action.payload.value) {
            addressBarURL.searchParams.delete("brokerCoOp")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.brokerCoOp = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("brokerCoOp")) {
            addressBarURL.searchParams.delete("brokerCoOp")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.brokerCoOp = "";
      }
    },
    addCashOnly: (state, action) => {
      const isExist = state.cashOnly === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("cashOnly")) {
            addressBarURL.searchParams.append("cashOnly", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          } else if (addressBarURL.searchParams.has("cashOnly") && !action.payload.value) {
            addressBarURL.searchParams.delete("cashOnly")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.cashOnly = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("cashOnly")) {
            addressBarURL.searchParams.delete("cashOnly")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.cashOnly = "";
      }
    },
    addCampaign: (state, action) => {
      const isExist = state.campaign === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("campaign")) {
            addressBarURL.searchParams.append("campaign", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.campaign = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("campaign")) {
            addressBarURL.searchParams.delete("campaign")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.campaign = "";
      }
    },
    addCampaignId: (state, action) => {
      const isExist = state.campaignId === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("campaignId")) {
            addressBarURL.searchParams.append("campaignId", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.campaignId = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("campaignId")) {
            addressBarURL.searchParams.delete("campaignId")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.campaignId = "";
      }
    },
    addCampaignType: (state, action) => {
      const isExist = state.campaignType === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("campaignType")) {
            addressBarURL.searchParams.append("campaignType", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.campaignType = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("campaignType")) {
            addressBarURL.searchParams.delete("campaignType")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.campaignType = "";
      }
    },
    addIsPartOfCampaign: (state, action) => {
      const isExist = state.isPartOfCampaign === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("isPartOfCampaign")) {
            addressBarURL.searchParams.append("isPartOfCampaign", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.isPartOfCampaign = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("isPartOfCampaign")) {
            addressBarURL.searchParams.delete("isPartOfCampaign")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.isPartOfCampaign = "";
      }
    },
    addOffers: (state, action) => {
      const isExist = state.offers === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("offers")) {
            addressBarURL.searchParams.append("offers", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.offers = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("offers")) {
            addressBarURL.searchParams.delete("offers")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.offers = "";
      }
    },
    addSearchBy: (state, action) => {
      const isExist = state.searchBy === action.payload.value;
      const isUpdate = action?.payload?.isUpdate;
      if (!isExist) {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (!addressBarURL.searchParams.has("searchBy")) {
            addressBarURL.searchParams.append("searchBy", action.payload.value)
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.searchBy = action.payload.value;
      } else {
        if (isUpdate) {
          //update Addressbar
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("searchBy")) {
            addressBarURL.searchParams.delete("searchBy")
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.searchBy = "";
      }
    },
    addPrice: (state, action) => {
      state.pageNumber = 1;
      state.price.min = action.payload.min;
      state.price.max = action.payload.max;
    },
    addPropertySubType: (state, action) => {
      const isExist = state.propertySubType.some(
        (item) => item === action.payload
      );
      if (!isExist) {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        let flag = false;
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "propertySubType" && value === action.payload) {
            flag = true
          }
        })
        if (!flag) {
          addressBarURL.searchParams.append("propertySubType", action.payload)
          history.pushState({}, "", addressBarURL.href)
        }
        //update Redux
        state.pageNumber = 1;
        state.propertySubType.push(action.payload);
      } else {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "propertySubType" && value === action.payload) {
            addressBarURL.searchParams.delete("propertySubType", action.payload)
          }
        })
        history.pushState({}, "", addressBarURL.href)
        //update Redux
        state.pageNumber = 1;
        state.propertySubType = state.propertySubType.filter(
          (item) => item !== action.payload
        );
      }
    },
    resetPropertySubType: (state, action) => {
      state.pageNumber = 1;
      state.propertySubType = [];
    },
    addCategory: (state, action) => {
      const assetId = action?.payload?.value;
      const isUpdate = action?.payload?.isUpdate;
      const isExist = state.category.some(
        (item) => item === assetId
      );
      if (!isExist) {
        //update Addressbar
        if (isUpdate) {
          let addressBarURL = new URL(window.location.href)
          let flag = false;
          addressBarURL.searchParams.forEach((value, key) => {
            if (key === "category" && value === assetId) {
              flag = true
            }
          })
          if (!flag) {
            addressBarURL.searchParams.append("category", assetId)
            history.pushState({}, "", addressBarURL.href)
          }
        }
        //update Redux
        state.pageNumber = 1;
        state.category.push(assetId);
      } else {
        //update Addressbar
        if (isUpdate) {
          let addressBarURL = new URL(window.location.href)
          addressBarURL.searchParams.forEach((value, key) => {
            if (key === "category" && value === assetId) {
              addressBarURL.searchParams.delete("category", assetId)
            }
          })
          history.pushState({}, "", addressBarURL.href)
        }
        //update Redux
        state.pageNumber = 1;
        state.category = state.category.filter(
          (item) => item !== assetId
        );
      }
    },
    resetCategory: (state, action) => {
      state.pageNumber = 1;
      state.category = [];
    },
    addPropertyStatus: (state, action) => {
      const isExist = state.propertyStatus.some(
        (item) => item === action.payload
      );
      if (!isExist) {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        let flag = false;
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "propertyStatus" && value === action.payload) {
            flag = true
          }
        })
        if (!flag) {
          addressBarURL.searchParams.append("propertyStatus", action.payload)
          history.pushState({}, "", addressBarURL.href)
        }
        //update Redux
        state.pageNumber = 1;
        state.propertyStatus.push(action.payload);
      } else {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "propertyStatus" && value === action.payload) {
            addressBarURL.searchParams.delete("propertyStatus", action.payload)
          }
        })
        history.pushState({}, "", addressBarURL.href)
        //update Redux
        state.pageNumber = 1;
        state.propertyStatus = state.propertyStatus.filter(
          (item) => item !== action.payload
        );
      }
    },
    resetPropertyStatus: (state, action) => {
      state.pageNumber = 1;
      state.propertyStatus = [];
    },
    addOccupancy: (state, action) => {
      const isExist = state.occupancyStatus.some(
        (item) => item === action.payload
      );
      if (!isExist) {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        let flag = false;
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "occupancyStatus" && value === action.payload) {
            flag = true
          }
        })
        if (!flag) {
          addressBarURL.searchParams.append("occupancyStatus", action.payload)
          history.pushState({}, "", addressBarURL.href)
        }
        //update Redux
        state.pageNumber = 1;
        state.occupancyStatus.push(action.payload);
      } else {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "occupancyStatus" && value === action.payload) {
            addressBarURL.searchParams.delete("occupancyStatus", action.payload)
          }
        })
        history.pushState({}, "", addressBarURL.href)
        //update Redux
        state.pageNumber = 1;
        state.occupancyStatus = state.occupancyStatus.filter(
          (item) => item !== action.payload
        );
      }
    },
    resetOccupancy: (state, action) => {
      state.pageNumber = 1;
      state.occupancyStatus = [];
    },
    addSpecialAssetsTypes: (state, action) => {
      const isExist = state.sid.some(
        (item) => item === action.payload
      );
      if (!isExist) {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        let flag = false;
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "sid" && value === action.payload) {
            flag = true
          }
        })
        if (!flag) {
          addressBarURL.searchParams.append("sid", action.payload)
          history.pushState({}, "", addressBarURL.href)
        }
        //update Redux
        state.pageNumber = 1;
        state.sid.push(action.payload);
      } else {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "sid" && value === action.payload) {
            addressBarURL.searchParams.delete("sid", action.payload)
          }
        })
        history.pushState({}, "", addressBarURL.href)
        //update Redux
        state.pageNumber = 1;
        state.sid = state.sid.filter(
          (item) => item !== action.payload
        );
      }
    },
    resetSpecialAssetsTypes: (state, action) => {
      state.pageNumber = 1;
      state.sid = [];
    },
    addFeatured: (state, action) => {
      const isExist = state.propertyShowMoreStatus.some(
        (item) => item === action.payload
      );
      if (!isExist) {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        let flag = false;
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "propertyShowMoreStatus" && value === action.payload) {
            flag = true
          }
        })
        if (!flag) {
          addressBarURL.searchParams.append("propertyShowMoreStatus", action.payload)
          history.pushState({}, "", addressBarURL.href)
        }
        //update Redux
        state.pageNumber = 1;
        state.propertyShowMoreStatus.push(action.payload);
      } else {
        //update Addressbar
        let addressBarURL = new URL(window.location.href)
        addressBarURL.searchParams.forEach((value, key) => {
          if (key === "propertyShowMoreStatus" && value === action.payload) {
            addressBarURL.searchParams.delete("propertyShowMoreStatus", action.payload)
          }
        })
        history.pushState({}, "", addressBarURL.href)
        //update Redux
        state.pageNumber = 1;
        state.propertyShowMoreStatus = state.propertyShowMoreStatus.filter(
          (item) => item !== action.payload
        );
      }
    },
    resetFeatured: (state, action) => {
      state.pageNumber = 1;
      state.propertyShowMoreStatus = [];
    },
    addPriceMin: (state, action) => {
      state.pageNumber = 1;
      state.price.min = action.payload;
    },
    addPriceMax: (state, action) => {
      state.pageNumber = 1;
      state.price.max = action.payload;
    },
    addAreaMin: (state, action) => {
      state.pageNumber = 1;
      state.area.min = action.payload;
    },
    addAreaMax: (state, action) => {
      state.pageNumber = 1;
      state.area.max = action.payload;
    },
    addBuiltYearMin: (state, action) => {
      state.pageNumber = 1;
      state.builtYear.min = action.payload;
    },
    addBuiltYearMax: (state, action) => {
      state.pageNumber = 1;
      state.builtYear.max = action.payload;
    },
    addBedrooms: (state, action) => {
      state.pageNumber = 1;
      state.bedrooms = action.payload;
    },
    addBathrooms: (state, action) => {
      state.pageNumber = 1;
      state.bathrooms = action.payload;
    },
    addSort: (state, action) => {
      state.pageNumber = 1;
      state.sort = action.payload;
    },
    addState: (state, action) => {
      state.pageNumber = 1;
      state.state = action.payload;
    },
    addMapParam: (state, action) => {
      state.pageNumber = 1;
      state.mapParam = action.payload;
    },
    setPageNumber: (state, action) => {
      let addressBarURL = new URL(window.location.href);
      if (addressBarURL.searchParams.has("pageNumber")) {
        addressBarURL.searchParams.delete('pageNumber')
        if (action.payload > 1) {
          addressBarURL.searchParams.append('pageNumber', action.payload)
        }
        history.pushState({}, '', addressBarURL.href)
      } else {
        if (action.payload > 1) {
          addressBarURL.searchParams.append('pageNumber', action.payload)
        }
        history.pushState({}, '', addressBarURL.href)
      }
      state.pageNumber = action.payload;
    },
    resetPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
  },
});

export const {
  addListingType,
  addNewToHubzu,
  addMarketingPhase,
  addAuctionEndingToday,
  addOwnItNow,
  addNobuyerpremium,
  addBrokerCoOp,
  addCashOnly,
  addCampaign,
  addCampaignId,
  addCampaignType,
  addIsPartOfCampaign,
  addOffers,
  addSearchBy,
  addPrice,
  addBathrooms,
  addBedrooms,
  addPriceMax,
  addPriceMin,
  addAreaMin,
  addAreaMax,
  addBuiltYearMin,
  addBuiltYearMax,
  addPropertySubType,
  resetPropertySubType,
  addCategory,
  resetCategory,
  addPropertyStatus,
  resetPropertyStatus,
  addOccupancy,
  resetOccupancy,
  addSpecialAssetsTypes,
  resetSpecialAssetsTypes,
  addFeatured,
  resetFeatured,
  addSort,
  addState,
  addMapParam,
  setPageNumber,
  resetPageNumber,
} = propertiesSlice.actions;
export default propertiesSlice.reducer;
